<template>
    <div id="canvasoverview">
        <div class="card canvases-list">
            <div class="card-content">
                <div class="productoverviewline top-buttons">
                    <ui5-button
                        @click="$router.push('/addcanvaspage')"
                        v-if="hasRight('productionmanagement')"
                    >
                        {{ trans('pages.canvas_overview.new_canvas') }}
                    </ui5-button>
                </div>

                <crm-table
                    v-if="initialFilters"
                    ref="canvasTable"
                    :use-global-scroll="true"
                    :columns="columns"
                    :items="canvases"
                    :count="canvases.length + 1"
                    :status="status"
                    @fetch="onFetch"
                    :default-filters="initialFilters"
                    default-sort="createdAt"
                    default-order="desc"
                    :has-sticky="false"
                >
                    <template v-slot:no-results>
                        {{ trans('pages.canvas_overview.no_canvases_found') }}
                    </template>
                    <template v-slot:actions="props">
                        <td>
                            <div>
                                <i
                                    class="fa fa-info-circle"
                                    @click="loadCanvasPage(props.item)"
                                />
                            </div>
                        </td>
                    </template>
                    <template v-slot:default_canvas="props">
                        <td>
                            {{
                                props.item.defaultCanvas
                                    ? trans('pages.canvas_overview.yes')
                                    : trans('pages.canvas_overview.no')
                            }}
                        </td>
                    </template>
                </crm-table>
            </div>
        </div>
    </div>
</template>
<script>
import Spinner from '../components/loader/Spinner';
import CrmTable from '../components/CrmTable';
import TextInput from '../components/TextInput';
import AutoCompleteInput from '../components/AutoCompleteInput';
import canvasApi from '../api/canvas';
import { mapGetters } from 'vuex';
import localization from '../mixins/localization';

export default {
    components: { Spinner, CrmTable, TextInput, AutoCompleteInput },
    mixins: [localization],
    data() {
        return {
            initialFilters: null,
            status: 'running',
            canvases: [],
            columns: [],
        };
    },
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
    },
    created() {
        this.columns = this.createColumns();
    },
    methods: {
        createColumns() {
            return [
                {
                    name: 'actions',
                    label: this.trans('pages.canvas_overview.columns.actions'),
                },
                {
                    name: 'code',
                    label: this.trans('pages.canvas_overview.columns.code'),
                    searchable: false,
                    sortable: false,
                },
                {
                    name: 'codeManufacturer',
                    label: this.trans(
                        'pages.canvas_overview.columns.manufacturer_code'
                    ),
                    searchable: false,
                    sortable: false,
                },
                {
                    name: 'manufacturer',
                    label: this.trans(
                        'pages.canvas_overview.columns.manufacturer'
                    ),
                    searchable: false,
                    sortable: false,
                },
                {
                    name: 'description',
                    label: this.trans(
                        'pages.canvas_overview.columns.description'
                    ),
                    searchable: false,
                    sortable: false,
                },
                {
                    name: 'defaultCanvas',
                    label: this.trans(
                        'pages.canvas_overview.columns.default_canvas'
                    ),
                    searchable: false,
                    sortable: false,
                    type: 'boolean',
                },
                {
                    name: 'sort',
                    label: this.trans('pages.canvas_overview.columns.sort'),
                    searchable: false,
                    sortable: false,
                },
            ];
        },

        onFetch(filters) {
            if (filters.page === 1) {
                this.canvases = [];
            }
            this.status = 'running';

            const limit = 50;
            const page = Math.floor(
                (this.canvases ? this.canvases.length : 0) / limit
            );

            const payload = {
                ...filters,
                page,
                limit,
            };

            this.$store.commit('canvasOverview/setFilters', filters, {
                root: true,
            });

            canvasApi
                .list(payload)
                .then((response) => {
                    const canvases = response.data;

                    canvases.forEach((item) => {
                        item.sortClasses = {};
                    });

                    if (!this.canvases) {
                        this.canvases = [];
                    }

                    canvases.forEach((canvas) => {
                        if (!this.canvases.find((x) => x.id == canvas.id)) {
                            this.canvases.push(canvas);
                        }
                    });

                    this.status = 'success';
                })
                .catch((err) => {
                    if (!axios.isCancel(err)) {
                        this.status = 'error';
                    }
                });
        },
        loadCanvasPage(canvas) {
            this.$router.push('/canvaspage/' + canvas.id);
        },
        fetchMore() {
            this.$refs.canvasTable.fetch(true);
        },
    },
    mounted() {
        this.initialFilters = this.$store.getters['canvasOverview/getFilters'];
    },
};
</script>
